import { icon, label, route } from "../../../../config";

export const ORGANISATION_APP_IDS = {
  COLLAB_CENTRAL: "collabCentral",
  DIRECTORY: "directory",
  STREAMS: "streams",
  WORKFLOWS: "workflows",
  FORMS: "forms",
  CHIPS: "chips",
  AUTOMATIONS: "automations",
  EMAILS: "emails",
  MY_CANVAS: "myCanvas",
};

/** Single Apps grid order (3×3). Directory omitted when feature is inactive. */
export const getOrganisationApps = (isDirectoryActive) => {
  const apps = [
    {
      id: ORGANISATION_APP_IDS.COLLAB_CENTRAL,
      text: label.COLLAB_CENTRAL,
      icon: icon.COLLAB_CENTRAL_APP,
    },
    {
      id: ORGANISATION_APP_IDS.DIRECTORY,
      text: label.BOARD_DIRECTORY,
      icon: icon.DIRECTORY_APP,
      hidden: !isDirectoryActive,
    },
    {
      id: ORGANISATION_APP_IDS.STREAMS,
      text: "Streams",
      icon: icon.STREAM_ICON,
      showStreamBadge: true,
    },
    {
      id: ORGANISATION_APP_IDS.WORKFLOWS,
      text: label.WORKFLOWS,
      icon: icon.WORKFLOW_LUCID,
    },
    {
      id: ORGANISATION_APP_IDS.FORMS,
      text: label.FORMS,
      icon: icon.APP_FORM,
    },
    {
      id: ORGANISATION_APP_IDS.CHIPS,
      text: label.SMART_CHIPS,
      icon: icon.SMART_CHIP,
    },
    {
      id: ORGANISATION_APP_IDS.AUTOMATIONS,
      text: label.AUTOMATIONS,
      icon: icon.APP_AUTOMATION,
    },
    {
      id: ORGANISATION_APP_IDS.EMAILS,
      text: label.EMAILS,
      icon: icon.EMAIL_ICON_BLUE,
    },
    {
      id: ORGANISATION_APP_IDS.MY_CANVAS,
      text: "My Canvas",
      icon: icon.CANVAS_APP,
    },
  ];

  return apps.filter((app) => !app.hidden);
};

export const getMyResourcesViews = () => {
  const state = store.getState();
  const { operationalTeamName } = state.auth.user;

  return [
    { label: label.OVERVIEW, icon: icon.CHART_LINE, text: label.OVERVIEW },
    { label: label.TEAM, icon: icon.MY_TEAM, text: operationalTeamName + "s" },
    { label: label.FORMS, icon: icon.APP_FORM, text: label.FORMS },
    { label: label.AUTOMATIONS, icon: icon.APP_AUTOMATION, text: label.AUTOMATIONS },
    { label: label.WORKSPACES, icon: icon.APP_WORKSPACE, text: label.WORKSPACES },
    { label: label.LIBRARY, icon: icon.APP_LIBRARY, text: label.LIBRARY },
    { label: label.EMAILS, icon: icon.EMAIL_ICON_BLUE, text: label.EMAILS },
    { label: label.STREAM, icon: icon.STREAM_ICON, text: "Streams" },
    { label: label.MY_CANVAS, icon: icon.CANVAS_APP, text: "My Canvas" },
  ];
};

export const routeWithBreadcrumbs = [
  route.PRIVATE_ROUTE.TASKS.PATH,
  route.PRIVATE_ROUTE.REMINDER.PATH,
  route.PRIVATE_ROUTE.WORKFLOW.PATH,
  route.PRIVATE_ROUTE.COMMENT.PATH,
  route.PRIVATE_ROUTE.NOTIFICATION.PATH,
  route.PRIVATE_ROUTE.USER_DIRECTORY.PATH,
  label.ROUTE_DOX,
  route.PRIVATE_ROUTE.PROJECT.PATH,
  route.PRIVATE_ROUTE.QUEUES.PATH,
  route.PRIVATE_ROUTE.EMAILS.PATH,
  route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH,
  route.PRIVATE_ROUTE.TASK_HISTORY.PATH,
  route.PRIVATE_ROUTE.TEAM_SETTING.PATH,
  route.PRIVATE_ROUTE.AUTOMATION_DETAIL.PATH,
  route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PATH,
  route.ADMIN_ROUTE.MANAGE_USERS.PATH,
  route.ADMIN_ROUTE.MANAGE_PROJECTS.PATH,
  route.ADMIN_ROUTE.USAGE_SUMMARY.PATH,
  route.ADMIN_ROUTE.MANAGE_UTILIZATION.PATH,
  route.ADMIN_ROUTE.ACTIVITY_LOG.PATH,
];
